function getUrlVars() {
    // Find the params in the URL, Used when linking from another site that has already screened for age
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function autotab(original, destination) {
    if (original.getAttribute && original.value.length == original.getAttribute("maxlength"))
        destination.focus()
}

function checkYearForSubmit() {
    if ($("#birthYear").val().length = 4) {
        $('#ageGateForm').submit();
    }
}

// Calculate your age based on inputs
$(function () {
    var day = $("#birthDay").val();
    var month = $("#birthMonth").val();
    var year = $("#birthYear").val();
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();

    // Disallow Letters into the Age Gate Input Fields
    $('#ageGateForm input.ageInput').on('input', function () {
        this.value = this.value.replace(/[\s\D]/g, '', function () {
        });
        if ($(this).val().length == $(this).attr('maxlength')) {
            if ($('#birthDay').val() > 31 || $('#birthMonth').val() > 12 || $('#birthYear').val() > currentYear) {
                $(this).val('');
            }
            if ($('html').hasClass('no-touch')) {
                $(this).parent().next().find('input.ageInput').focus();
            }
        };
    });

    $(function () {
        const bodySelect = document.getElementsByTagName("BODY")[0];
        var ageModalSelect = document.getElementById("ageModal");
        var gateParam = getUrlVars()["agegate"];
        // If There is no Age Cookie or Cookie is set to Failed Hide Contents of Page and display Age Gate PopUp
        if ($.cookie('age_verify') == 'underage' || $.cookie('age_verify') == null) {
            ageModalSelect.classList.add("show");
            bodyScrollLock.disableBodyScroll(bodySelect);
        }

        // If Cookie is found and True Show Contents of Page and Remove Age Gate modal
        if ($.cookie('age_verify') == 'legal' || gateParam == 'valid') {
            $.cookie('age_verify', 'legal', { path: '/' });
            ageModalSelect.classList.remove("show");
          	$('html, body').animate({scrollTop : 0},1);
            bodyScrollLock.clearAllBodyScrollLocks();
            return false;
        }
    });


    // FORM Submit 
    $("#ageGateForm").submit(function () {
        var day = $("#birthDay").val();
        var month = $("#birthMonth").val();
        var year = $("#birthYear").val();
        var age = $("#requiredAge").val();

        // if single digits are entered for month and day try padding it with a 0 to make two digits
        if (day.length == 1) {
            day = ("0" + day).slice(-2);
        }
        if (month.length == 1) {
            month = ("0" + month).slice(-2);
        }

        // If Input fields are left empty or not formatted correctly....
        if (day == "" || month == "" || year == "" || month.length < 2 || day.length < 2 || year.length < 4) {
            return false
        }
        var mydate = new Date();
        mydate.setFullYear(year, month - 1, day);

        var currdate = new Date();
        currdate.setFullYear(currdate.getFullYear() - age);

        //  If Underage Redirect to Google Homepage 
        if ((currdate - mydate) < 0) {
            $.cookie('age_verify', 'underage', { path: '/' });
            window.location.assign("https://drinkwise.org.au");
            return false
        }

        // If Age is Validated Hide form and show contents
        else {
            $.cookie('age_verify', 'legal', { path: '/' });
            $("body").removeClass("lockscroll");
            var ageModalSelect = document.getElementById("ageModal");
            ageModalSelect.classList.remove("show");
          	$('html, body').animate({scrollTop : 0},1);
            bodyScrollLock.clearAllBodyScrollLocks();
            return false
        }

    });
});